import loadingComponent from './loading.vue';
let $vm;
export default {
  install(Vue, options={}) {
    if (!$vm) {
      const LoadingPlugin = Vue.extend(loadingComponent);
      $vm = new LoadingPlugin({});
      document.body.appendChild($vm.$mount().$el);
    }
    $vm.show = true;
    let loading = {
      show() {
        $vm.show = true;
      },
      hide() {
        console.log('test')
        $vm.show = false;
      }
    }
    if (!Vue.$loading) {
      Vue.$loading = loading;
    }
    Vue.mixin({
      created() {
        this.$loading = Vue.$loading;
      }
    })
  }
}



